import styled from 'styled-components';
import { IThemeProps } from 'store/ducks/globalTypes';
import { themesList } from 'constants/themesList';

export const DashboardContainer = styled.div<IThemeProps>`
  padding: 28px;
  min-height: 100vh;
  background: ${({ scheme }) => {
    const t = themesList[scheme as keyof typeof themesList];
    return t?.colorBgLayout || themesList.deepBlueTheme.colorBgLayout;
  }};
`;

export const DashboardTitle = styled.h2`
  margin: 0 0 20px;
  font-weight: 600;
  color: #111827;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: minmax(500px, 700px);
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 18px;
  border: 1px solid #eef1f6;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
`;

export const CardTitle = styled.div`
  font-size: 15px;
  margin-bottom: 14px;
  color: #1f2937;
  font-weight: 600;
  letter-spacing: 0.3px;
`;

export const ChartWrapper = styled.div`
  padding-top: 6px;
`;
